import React from "react";
import { Helmet } from "react-helmet";
import { useIntl } from "react-intl";
import { FormattedMessage } from "react-intl";
import { Outlet, useOutletContext } from "react-router";
import { NavList, SubNav } from "components/Nav";
import { Grid, PageWrapper } from "components/Containers";
import { SignalNotice } from "components/Squads/settings";
import { useAuth, useLinks } from "hooks";

/**
 * Engineering
 */
const Engineering = () => {
  const intl = useIntl();
  const parentContext = useOutletContext();
  const { isClient, isSignalClient } = useAuth();
  const links = useLinks();

  return (
    <>
      <Helmet>
        <title>{intl.formatMessage({ id: "Meta.Squads.Engineering.Title" })}</title>
      </Helmet>
      <SubNav>
        <NavList pages={NAV_ITEMS(parentContext.id, links)} />
      </SubNav>
      <PageWrapper>
        {(isSignalClient || isClient) && !parentContext.loading && (
          <Grid topMargin>
            <Grid.col start={1} end={13}>
              <SignalNotice teamData={parentContext.selectedSquad} />
            </Grid.col>
          </Grid>
        )}
        <Outlet context={{ ...parentContext }} />
      </PageWrapper>
    </>
  );
};

const NAV_ITEMS = (id, links) => [
  {
    label: <FormattedMessage id="Squads.SquadSubNav.Engineering.CodeTelemetry" />,
    to: links.squad_engineering(id),
    props: {
      end: true,
    },
  },
  {
    label: <FormattedMessage id="Squads.SquadSubNav.Engineering.Activity" />,
    to: links.squad_activity_report(id),
    props: {
      end: true,
    },
  },
  {
    label: <FormattedMessage id="Squads.SquadSubNav.Engineering.ActivityAllTime" />,
    to: links.squad_activity_all_time(id),
    props: {
      end: true,
    },
  },
];

export default Engineering;
